//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ModalForbidden',
  data() {
    return {
    }
  },
  methods: {
    beforeOpen (event) {
      window.dispatchEvent(new Event('resize'));
    },
    close() {
      this.$modal.hide('modal-forbidden')
    }
  }
}
